import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Wrench, MapPin, ChevronRight } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { fmtTime } from "@/lib/format";
import { Panel, SectionLabel } from "@/components/common/ui-kit";
import { ItvStatus, SlaBadge } from "@/components/interventions/ItvBadges";

export const TechTodayCard = () => {
  const { can } = useAuth();
  const [items, setItems] = useState(null);
  const tech = can("interventions:execute");
  useEffect(() => {
    if (tech) api.get("/interventions", { params: { mine: true, day: "today", sort: "scheduled_at", limit: 20 } }).then((r) => setItems(r.data.items)).catch(() => setItems([]));
  }, [tech]);
  if (!tech || !items || (!items.length && can("interventions:plan"))) return null;
  return (
    <Panel className="mb-6 p-5" data-testid="tech-today-card">
      <div className="flex items-center justify-between">
        <SectionLabel>I tuoi interventi di oggi</SectionLabel>
        <span className="font-mono text-xs text-slate-500" data-testid="tech-today-count">{items.length}</span>
      </div>
      {!items.length && <p className="mt-3 text-sm text-slate-500" data-testid="tech-today-empty">Nessun intervento pianificato per oggi.</p>}
      <ol className="mt-3 divide-y divide-line">
        {items.map((i) => (
          <li key={i.id}>
            <Link to={`/interventi/${i.id}`} className="flex items-center gap-3 py-3" data-testid={`tech-today-${i.id}`}>
              <span className="w-12 shrink-0 font-mono text-sm font-bold text-ink">{fmtTime(i.scheduled_at)}</span>
              <Wrench className="h-4 w-4 shrink-0 text-rose-600" />
              <div className="min-w-0 flex-1">
                <p className="truncate text-sm font-semibold text-ink">{i.company_name} · {i.title}</p>
                {i.address && <p className="flex items-center gap-1 truncate text-xs text-slate-500"><MapPin className="h-3 w-3 shrink-0" />{i.address}</p>}
              </div>
              <div className="hidden items-center gap-1.5 sm:flex"><SlaBadge itv={i} /><ItvStatus status={i.status} /></div>
              <ChevronRight className="h-4 w-4 text-slate-400" />
            </Link>
          </li>
        ))}
      </ol>
    </Panel>
  );
};
